import { initCDP, setCDPUserName, CdpProjectType } from '@4f2e/cg-addon';

const environment = {
  DEV: 'dev',
  FAT: 'test',
  UAT: 'stag',
  PROD: 'prod',
}[process.env.CONFIG_ENV.toUpperCase() || 'DEV'];

initCDP({
  // @ts-ignore
  env: environment,
  appId: 'srm-vendor-portal-fe',
  project: CdpProjectType.Internal,
});

setCDPUserName('noname');
